export default "__VITE_ASSET__CaNG6CDG__"